import ENV from "../constants/env-constants";
import messages from "../constants/messages";

export async function getImpactBannerDetails() {
    try {
        const response = await fetch(`${ENV.API_URL}/api/impact-details`, { method: 'GET' });

        // Check if the response status is OK (status code 200-299)
        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }

        // Parse the response body as JSON
        const data = await response.json();
        console.log('response', response);
        console.log('response body', data);

        return data;
    } catch (error) {
        console.error('Error fetching impact banner details:', error);
        throw error;
    }
}

export async function subscribeEmailList(email) {
    try {
        const response = await fetch(`${ENV.API_URL}/api/subscribe-email-list/${email}`, { method: 'GET' });

        // Check if the response status is OK (status code 200-299)
        if (response.status === 201) {
            return messages.ADDED;
        } else if (response.status === 409) {
            return messages.ALREADY_EXISTED
        } else if (response.status === 500) {
            return messages.INTERNAL_SERVER_ERROR
        } else return messages.STATUS_UNKNOWN;
    } catch (error) {
        console.error('Error fetching impact banner details:', error);
        throw error;
    }
}